export default class smoothScroll {

    constructor() {
        var $window = $(window);
        var scrollTime = 1.3;
        var scrollDistance = 400;
        $window.on("mousewheel DOMMouseScroll", function(event){
            event.preventDefault();
            var delta = event.originalEvent.wheelDelta/120 || -event.originalEvent.detail/3;
            var scrollTop = $window.scrollTop();
            var finalScroll = scrollTop - parseInt(delta*scrollDistance);
            TweenMax.to($window, scrollTime, {
                scrollTo : { y: finalScroll, autoKill:true },
                ease: Expo.easeOut,
                overwrite: 5
            });
        });
    }


}


// WEBPACK FOOTER //
// ./src/scripts/helpers/smoothscroll.js